/**
 * @Author: zhangxiaojian
 * @Date: 2025/5/27
 * @LastEditors: zhangxiaojian
 * @Description 打包后对createAPI、requestCommonAPI方法中的url参数进行加密处理，如需在此文件中对url进行二次处理，请先调用decryptUrl解密
 **/

import { createAPI } from '@common'
/**
 * 对api请求进行二次封装，注意：因在打包后会对url进行加密处理在该方法内请勿直接操作url，如需操作可引用common中decryptUrl先进行解密再操作
 * @param url
 * @param action
 * @param config
 * @param vconfig
 * @returns {*}
 */
const requestCommonAPI = function (url, action, config) {
  return createAPI(url, action, config, {
    hubForward: true,
    hub: '/v1/newsplan/hub'
  })
}
export default {
  // 地域列表
  postHotTopicRegions: (config) =>
    requestCommonAPI('customEncryptApiName-1/0bqj0ipuupqjd0sfhjpot', 'post', config),
  // 通用检索
  postFts: (config) => requestCommonAPI('customEncryptApiName-1/0bqj0gut', 'post', config),
  // 热点列表
  postHotTopicTopics: (config) =>
    requestCommonAPI('customEncryptApiName-1/0bqj0ipuupqjd0upqjdt', 'post', config),
  // 热点详情
  postHotTopicTopic: (config) =>
    requestCommonAPI('customEncryptApiName-1/0bqj0ipuupqjd0upqjd', 'post', config),
  // 相关报道
  postHotTopicDocuments: (config) =>
    createAPI('customEncryptApiName-1/0bqj0ipuupqjd0epdvnfout', 'post', config, {
      hubForward: true,
      hub: '/v1/newsplan/hub',
      neverLoading: true
    }),
  // 总声量发展趋势
  postHotTopicTopicTrendPubdate: (config) =>
    requestCommonAPI('customEncryptApiName-1/0bqj0ipuupqjd0upqjd0usfoe0qvcebuf', 'post', config),
  // 渠道声量发展趋势
  postHotTopicTopicTrendDatatype: (config) =>
    requestCommonAPI('customEncryptApiName-1/0bqj0ipuupqjd0upqjd0usfoe0ebubuzqf', 'post', config),
  // 主要媒体声量
  postHotTopicTopicCountSource: (config) =>
    requestCommonAPI('customEncryptApiName-1/0bqj0ipuupqjd0upqjd0dpvou0tpvsdf', 'post', config),
  // 新闻详情
  postHotTopicDocument: (config) =>
    requestCommonAPI('customEncryptApiName-1/0bqj0ipuupqjd0epdvnfou', 'post', config),
  // 本地新闻--地域
  postMediaRegionProvinceAndCities: (config) =>
    requestCommonAPI('customEncryptApiName-1/0bqj0nfejb0sfhjpo0qspwjodfBoeDjujft', 'post', config),
  // 本地新闻--列表
  postQueryMedia: (config) =>
    requestCommonAPI('customEncryptApiName-1/0bqj0rvfsz0nfejb', 'post', config),
  // 本地新闻--稿件详情
  postFtsDocument: (config) =>
    requestCommonAPI('customEncryptApiName-1/0bqj0gut0epdvnfou', 'post', config),
  // 突发事件--事件分类
  postEventBreakoutTypes: (config) =>
    requestCommonAPI('customEncryptApiName-1/0bqj0fwfou0csfblpvu0uzqft', 'post', config),
  // 突发事件--列表
  postEventBreakoutDoclist: (config) =>
    requestCommonAPI('customEncryptApiName-1/0bqj0fwfou0csfblpvu0epdmjtu', 'post', config),
  // 舆情库数据类型
  postDatatypeYuqing: (config) =>
    requestCommonAPI('customEncryptApiName-1/0bqj0ebubuzqf0zvrjoh', 'post', config),
  // 主题事件--事件级别
  postEventLevels: (config) =>
    requestCommonAPI('customEncryptApiName-1/0bqj0fwfou0mfwfmt', 'post', config),
  // 主题事件--事件列表
  postEventList: (config) =>
    requestCommonAPI('customEncryptApiName-1/0bqj0fwfou0mjtu', 'post', config),
  // 主题事件--数据类型
  postDatatypeMedia: (config) =>
    requestCommonAPI('customEncryptApiName-1/0bqj0ebubuzqf0nfejb', 'post', config),
  // 主题事件--事件文章列表
  postEventDoclist: (config) =>
    requestCommonAPI('customEncryptApiName-1/0bqj0fwfou0epdmjtu', 'post', config),
  // 主题事件--事件新增
  postEventAdd: (config) => requestCommonAPI('customEncryptApiName-1/0bqj0fwfou0bee', 'post', config),
  // 主题事件--事件详情
  postEventDetail: (config) =>
    requestCommonAPI('customEncryptApiName-1/0bqj0fwfou0efubjm', 'post', config),
  // 主题事件--事件修改
  postEventUpdate: (config) =>
    requestCommonAPI('customEncryptApiName-1/0bqj0fwfou0vqebuf', 'post', config),
  // 主题事件--事件删除
  postEventdelete: (config) =>
    requestCommonAPI('customEncryptApiName-1/0bqj0fwfou0efmfuf', 'post', config),
  // 政府发布--信源类型
  postDatatypeSubscribeOfficial: (config) =>
    requestCommonAPI('customEncryptApiName-1/0bqj0ebubuzqf0tvctdsjcf0pggjdjbm', 'post', config),
  // 政府发布--分组名称、党报聚焦--分组名称（共用一个接口）
  postSubscribeGroups: (config) =>
    requestCommonAPI('customEncryptApiName-1/0bqj0tvctdsjcf0hspvqt', 'post', config),
  // 政府发布--订阅网站、党报聚焦--订阅数字报（共用一个接口）
  postSubscribeSourceSubscribed: (config) =>
    requestCommonAPI('customEncryptApiName-1/0bqj0tvctdsjcf0tpvsdf0tvctdsjcfe', 'post', config),
  // 政府发布--列表
  postSubscribeDoclist: (config) =>
    requestCommonAPI('customEncryptApiName-1/0bqj0tvctdsjcf0epdmjtu', 'post', config),
  // 聚焦区县--媒体级别接口
  postSourceLevelsByCategory: (config) =>
    requestCommonAPI('customEncryptApiName-1/0bqj0tpvsdf0mfwfmtCzDbufhpsz', 'post', config),
  // 聚焦区县--文章列表
  postLocalnewsMedia: (config) =>
    requestCommonAPI('customEncryptApiName-1/0bqj0mpdbmofxt0nfejb', 'post', config),
  // 分类热点--地域列表
  postHpttopicCategories: (config) =>
    requestCommonAPI('customEncryptApiName-1/0bqj0ipuupqjd0dbufhpsjft', 'post', config),
  // 分类热点--文章列表
  postHottopicTopics: (config) =>
    requestCommonAPI('customEncryptApiName-1/0bqj0ipuupqjd0upqjdt', 'post', config),
  // 新闻推荐--栏目订阅列表树查询
  postSubscribeColumnTree: (config) =>
    requestCommonAPI('customEncryptApiName-1/0bqj0tvctdsjcf0dpmvno0usff', 'post', config),
  // 新闻推荐--栏目订阅信息列表查询
  postSubscribeColumnQuery: (config) =>
    requestCommonAPI('customEncryptApiName-1/0bqj0tvctdsjcf0dpmvno0rvfsz', 'post', config)
}
